import {
    GET_IMPERSONATION_USERDATA,
    GET_IMPERSONATION_USERDATA_FAILURE,
    GET_IMPERSONATION_USERDATA_SUCCESS,
} from '../actions';
import { persistReducer } from 'redux-persist';
import { US_COUNTRY_CODE } from 'src/constants/appConstants';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
const initialState = {
    employeeRole: '',
    salesStructure: '',
    displayName: '',
    impersonationUserError: '',
    loading: false,
    hybrisUserDetails: {},
};

const getImpersonatedUserData = (state = initialState, action) => {
    switch (action.type) {
        case GET_IMPERSONATION_USERDATA:
            return {
                ...state,
                loading: true,
            };
        case GET_IMPERSONATION_USERDATA_SUCCESS:
            return {
                ...state,
                employeeRole: action.data.employeeRole,
                hybrisUserDetails: {
                    countryISOCode: US_COUNTRY_CODE,
                    ...action.data,
                },
                districts:
                    action.data.salesStructure &&
                    action.data.salesStructure.length
                        ? action.data.salesStructure
                              .filter((item) => item.districtCode)
                              .map((item) => item.district)
                        : [],
                displayName:
                    typeof action.data.displayName !== 'undefined' &&
                    action.data.displayName !== 'undefined'
                        ? action.data.displayName
                        : '',
                loading: false,
            };
        case GET_IMPERSONATION_USERDATA_FAILURE:
            return {
                ...state,
                impersonationUserError: true,
                hybrisUserDetails: { employeeRole: null },
                loading: false,
            };

        default: {
            return { ...state };
        }
    }
};

// export default getImpersonatedUserData;
export default persistReducer(
    {
        key: 'impersonationUserKey',
        storage: storage,
        whitelist: ['employeeRole', 'districts', 'displayName'],
    },
    getImpersonatedUserData
);
